<template>
  <div class="flex flex-col gap-2 text-brand-black-secondary">
    <slot name="labelSlot">
      <label
        v-if="label"
        :for="field.name"
        :class="labelClass"
        class="w-full flex items-center gap-x-2"
      >
        <div>
          <span> {{ t9nLabel }}</span>
        </div>
        <HintTippy v-if="hint" :hint="hint"></HintTippy>
      </label>
    </slot>
    <div class="w-full relative flex flex-wrap gap-3">
      <label
        :for="option.label"
        :key="key"
        v-for="(option, key) in radioOptions"
        class="cursor-pointer flex items-center gap-2 accent-primary"
      >
        <input
          :id="option.label"
          :value="option.value"
          :name="field.name"
          :checked="defaultValue === option.value"
          type="radio"
          @change="$emit('onChange', option)"
        />
        {{ $t(option.label) }}
      </label>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import HintTippy from '@/components/Form/HintTyppy.vue'

const props = defineProps({
  label: String,
  field: Object,
  errors: Array,
  name: String,
  labelClass: String,
  disabled: Boolean,
  hint: String,
  direction: {
    type: String,
    default: 'flex-row md:items-center'
  },
  isRequired: {
    type: Boolean,
    default: () => true
  },
  isReadOnly: Boolean,
  radioOptions: {
    type: Array,
    required: true
  },
  defaultValue: [String, Number, Boolean]
})

const i18n = useI18n()

const t9nLabel = computed(() => i18n.t(props.label))
</script>

<style lang="scss" scoped></style>
